module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_7005.9c772c32.png";